"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const HostsTable_1 = require("../../../../common/components/hosts/HostsTable");
const common_1 = require("../../../../common");
const AdditionaNTPSourceDialogToggle_1 = require("../../hosts/AdditionaNTPSourceDialogToggle");
const use_hosts_table_1 = require("../../hosts/use-hosts-table");
const NetworkConfigurationTableBase_1 = tslib_1.__importDefault(require("./NetworkConfigurationTableBase"));
const NetworkConfigurationTable = ({ cluster }) => {
    const _a = (0, use_hosts_table_1.useHostsTable)(cluster), { actionChecks, onEditHost, actionResolver } = _a, modalProps = tslib_1.__rest(_a, ["actionChecks", "onEditHost", "actionResolver"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(NetworkConfigurationTableBase_1.default, { cluster: cluster, AdditionalNTPSourcesDialogToggleComponent: AdditionaNTPSourceDialogToggle_1.AdditionalNTPSourcesDialogToggle, onEditHost: onEditHost, canEditHostname: actionChecks.canEditHostname, actionResolver: actionResolver },
            React.createElement(HostsTable_1.HostsTableEmptyState, { isSNO: (0, common_1.isSNO)(cluster) })),
        React.createElement(use_hosts_table_1.HostsTableModals, Object.assign({ cluster: cluster }, modalProps))));
};
exports.default = NetworkConfigurationTable;
//# sourceMappingURL=NetworkConfigurationTable.js.map